import React from 'react'
import ReactToPrint from 'react-to-print';

export class ModalImpressaoCupomReservaPassageiro extends React.Component {
  constructor (props) {
    super(props);    
  }

  exibirBotaoImprimir () {
    return (   
        <React.Fragment>
            <ReactToPrint
                trigger={() => <button className="btn btn-laranja">Imprimir
                </button>}
                content={() => this.props.componentRef.current}
            />
        </React.Fragment>
    )
  }

  render () {
    if (this.props.componentRef) {      
      return (
        <div className="modal fade show" id='modalImpressaoCupomReservaPassageiro' role='dialog'
             aria-labelledby='modalImpressaoCupomReservaPassageiro' aria-hidden='true' data-backdrop='static'>
          <div className={'modal-dialog modal-dialog-centered modal-md'}>
            <div className="modal-content">
              <div className="modal-header">
                <h5>Imprimir Passagem </h5>                
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                        onClick={() => {
                          this.props.limparReservaSelecionada();
                          this.props.limparPedidoSelecionado();
                        }}>
                  <i className="material-icons">
                    &#xe5cd;
                  </i>
                </button>
              </div>
              <div className="modal-body">
                <p>Deseja realizar a impressão do passageiro(a) {this.props.reservaSelecionada && this.props.reservaSelecionada.passageiroDto.nome}?</p>                 
              </div>
              <div className="modal-footer">
                {this.exibirBotaoImprimir()}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return '';
  }
}


export default ModalImpressaoCupomReservaPassageiro
